import { Link } from 'react-router-dom';
import ContactForm from '../Common/ContactForm';
import { FBA_PREP_CONTACT_PATH, FBA_PREP_PRIMARY_CTA } from './fbaPrepCta';
import './FbaPricingTrustBlock.css';

const PRICING_ROWS = [
  {
    service: 'Standard Labeling',
    price: 'From £0.30',
    included: 'Receiving, Inspection, FNSKU Labeling',
  },
  {
    service: 'Bagging & Prep',
    price: 'From £0.35',
    included: 'Polybagging, Suffocation Warning, Suffocation Label',
  },
  {
    service: 'Multipack / Bundling',
    price: 'From £0.40',
    included: 'Collation, Shrink-wrap/Bagging, New Barcode',
  },
] as const;

export default function FbaPricingTrustBlock() {
  return (
    <section className="fba-pricing-trust-tier" id="fba-pricing-trust" aria-labelledby="fba-pricing-trust-heading">
      <div className="fba-pricing-trust-inner">
        <div className="fba-pricing-trust-pricing">
          <h2 id="fba-pricing-trust-heading">Transparent UK FBA Prep Pricing</h2>
          <p className="fba-pricing-trust-lead">
            Our standard prep packages start from just <strong>30p per unit</strong>. No hidden setups.
            No contract lock-ins.
          </p>

          <div className="fba-pricing-trust-table-wrap">
            <table className="fba-pricing-table">
              <caption className="sr-only">Starting FBA prep prices per unit at Pick Pack Pro UK</caption>
              <thead>
                <tr>
                  <th scope="col">Service Item</th>
                  <th scope="col">Starting Price (Per Unit)</th>
                  <th scope="col">What&apos;s Included</th>
                </tr>
              </thead>
              <tbody>
                {PRICING_ROWS.map((row) => (
                  <tr key={row.service}>
                    <td>
                      <strong>{row.service}</strong>
                    </td>
                    <td>{row.price}</td>
                    <td>{row.included}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <p className="fba-pricing-trust-link-row">
            <Link to="/amazon-fba-prep-pricing" className="fba-pricing-trust-inline-link">
              View Our Full, Detailed Pricing Breakdown →
            </Link>
          </p>

          <Link to={FBA_PREP_CONTACT_PATH} className="fba-pricing-trust-primary-cta">
            {FBA_PREP_PRIMARY_CTA}
          </Link>
        </div>

                <div className="amazon-fba-pricing-form-wrapper" style={{ background: '#ffffff', padding: '32px', borderRadius: '16px', width: '100%', boxShadow: '0 20px 40px rgba(0,0,0,0.2)', maxWidth: '400px' }}>
          <h2 style={{ marginTop: 0, marginBottom: '24px', fontSize: '1.5rem', color: '#1a1a1a', fontWeight: 'bold' }}>Get an FBA Prep Quote</h2>
          <ContactForm source="amazon-fba-prep-services" isFbaPrep={true} />
        </div>
      </div>
    </section>
  );
}
